export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10924.91a3a3de.jpg";